exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".free-trial-expired{background-color:#f2eb93;color:#3d3d3d;font-size:1.2rem;padding:.125em 0}\n", ""]);
